import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UtilFns } from '@utils';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { AutoFocusModule } from 'primeng/autofocus';
import { AuthService } from '../../services/auth.service';

@Component({
  imports: [InputTextModule, ButtonModule, FormsModule, RouterModule, PasswordModule, AutoFocusModule],
  templateUrl: './login.component.html',
  styleUrls: ['./auth-shell.scss'],
})
export class LoginComponent {
  error = '';
  errorIsSoft = false;
  success = '';
  working = false;
  username = '';
  password = '';

  constructor(private authService: AuthService) { }

  async onSubmit() {
    this.error = '';
    this.errorIsSoft = false;
    if (this.working) { return; }

    this.working = true;
    try {
      await this.authService.login(this.username, this.password, false);
      this.error = '';
      // const user = this._authService.getUser();
      this.success = 'Logged in';
      this.working = false;

    } catch (err: any) {
      if (err.status === 0) {
        this.error = 'Unable to contact server';
      } else if (err.status === 401) {
        this.error = err.error || 'Invalid login name or password';
      } else {
        //   this._logger.log(error, 'error');
        this.error = UtilFns.getErrorMessage(err);
      }
      this.errorIsSoft = /on-hold or inactive/i.test(this.error);
      this.working = false;
    }

  }
}
